<!-- Vista de gestión para mentores y expertos -->
<div class="academy-management-container" *ngIf="isManagementView">
  <!-- Header -->
  <div class="management-header">
    <div class="header-content">
      <h1 class="management-title">Academy</h1>
      <p class="management-subtitle">Sube tus archivos aqui</p>
    </div>
    <button class="btn-add-new" (click)="openDocumentModal()">
      Agregar nuevo
    </button>
  </div>

  <!-- Filtros y búsqueda -->
  <div class="management-filters">
    <div class="search-field">
      <input 
        type="text" 
        class="search-input" 
        placeholder="Buscar por título"
        [(ngModel)]="searchTitle"
        (input)="filterDocuments()">
      <i class="fas fa-search search-icon"></i>
    </div>
    
    <div class="filter-field">
      <label for="status-filter">Filtrar estado</label>
      <select 
        id="status-filter" 
        class="filter-select"
        [(ngModel)]="statusFilter"
        (change)="filterDocuments()">
        <option value="">Todos</option>
        <option value="Activo">Activo</option>
        <option value="Inactivo">Inactivo</option>
        <option value="En revision">En revision</option>
        <option value="Borrador">Borrador</option>
      </select>
      <i class="fas fa-chevron-down select-icon"></i>
    </div>
    
    <div class="filter-field">
      <label for="dimension-filter">Filtrar dimensión</label>
      <select 
        id="dimension-filter" 
        class="filter-select"
        [(ngModel)]="dimensionFilter"
        (change)="filterDocuments()">
        <option value="">Todas</option>
        <option *ngFor="let dim of dimensions" [value]="dim.name">{{ dim.name }}</option>
      </select>
      <i class="fas fa-chevron-down select-icon"></i>
    </div>
  </div>

  <!-- Tabla de documentos -->
  <div class="management-table-container">
    <table class="management-table">
      <thead>
        <tr>
          <th class="col-title">
            Titulo
            <i class="fas fa-chevron-down sort-icon"></i>
          </th>
          <th class="col-status">Estado</th>
          <th class="col-dimension">Dimensión</th>
          <th class="col-date">Fecha de publicación</th>
          <th class="col-type">Tipo</th>
          <th class="col-actions">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let paper of getPaginatedDocuments()">
          <td class="col-title">{{ paper.title }}</td>
          <td class="col-status">
            <span class="status-badge" [ngClass]="'status-' + getPaperStatusClass(paper)">
              {{ getPaperStatus(paper) }}
            </span>
          </td>
          <td class="col-dimension">
            <div class="paper-dimensions-list">
              <span 
                class="dimension-tag-small" 
                *ngFor="let dimensionId of getPaperDimensionsArray(paper.category)"
                [title]="getDimensionNameById(dimensionId)"
              >
                {{getDimensionNameById(dimensionId)}}
              </span>
              <span *ngIf="!paper.category || getPaperDimensionsArray(paper.category).length === 0" class="no-dimension">
                Sin dimensión
              </span>
            </div>
          </td>
          <td class="col-date">{{ paper.publishedDate ? (paper.publishedDate | date:'dd/MM/yyyy') : '-' }}</td>
          <td class="col-type">PDF</td>
          <td class="col-actions">
            <button class="action-btn edit-btn" (click)="editDocument(paper)" title="Editar">
              <i class="fas fa-pencil-alt"></i>
            </button>
            <button class="action-btn view-btn" (click)="navigateToPublicPaper(paper._id)" title="Vista previa en portal">
              <i class="fas fa-eye"></i>
            </button>
            <!-- <button class="action-btn delete-btn" (click)="disableDocument(paper)" title="Inhabilitar">
              <i class="fas fa-ban"></i>
            </button> -->
          </td>
        </tr>
        <tr *ngIf="getPaginatedDocuments().length === 0">
          <td colspan="6" class="no-data">
            No hay documentos disponibles
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Paginación -->
  <div class="management-pagination" *ngIf="totalPagesManagement > 1">
    <div class="pagination-controls">
      <button 
        class="pagination-btn prev-btn" 
        [disabled]="currentPageManagement === 1"
        (click)="previousPageManagement()">
        <i class="fas fa-chevron-left"></i>
      </button>
      
      <div class="page-numbers">
        <button 
          *ngFor="let page of getPageNumbersManagement()" 
          class="page-btn"
          [class.active]="page === currentPageManagement"
          (click)="goToPageManagement(page)">
          {{ page }}
        </button>
        <span *ngIf="totalPagesManagement > 10 && currentPageManagement < totalPagesManagement - 2" class="dots">...</span>
        <button 
          *ngIf="totalPagesManagement > 10 && currentPageManagement < totalPagesManagement - 2"
          class="page-btn"
          (click)="goToPageManagement(totalPagesManagement)">
          {{ totalPagesManagement }}
        </button>
      </div>
      
      <button 
        class="pagination-btn next-btn" 
        [disabled]="currentPageManagement === totalPagesManagement"
        (click)="nextPageManagement()">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
    
    <div class="pagination-info">
      <span>Mostrando {{ ((currentPageManagement - 1) * itemsPerPageManagement) + 1 }} de {{ totalItemsManagement }} resultados</span>
    </div>
    
    <div class="items-per-page">
      <span>Mostrar</span>
      <select 
        class="items-select" 
        [value]="itemsPerPageManagement" 
        (change)="changeItemsPerPageManagement(+($any($event.target).value))">
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="50">50</option>
      </select>
    </div>
  </div>

  <!-- Modal de formulario -->
  <div class="modal-overlay" *ngIf="showDocumentModal" (click)="closeDocumentModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="modal-title">Información del documento</h2>
        <button class="modal-close" (click)="closeDocumentModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      
      <div class="modal-divider"></div>
      
      <div class="modal-body">
        <form class="document-form">
          <!-- Nombre y Profesión -->
          <div class="form-row">
            <div class="form-field">
              <label class="field-label">Nombre</label>
              <input 
                type="text" 
                class="field-input" 
                [value]="getUserDisplayName()"
                readonly>
            </div>
            <div class="form-field">
              <label class="field-label">Profesión</label>
              <input 
                type="text" 
                class="field-input" 
                [value]="getUserProfession()"
                readonly>
            </div>
          </div>
          
          <!-- Dimensión y Título -->
          <div class="form-row">
            <div class="form-field">
              <label class="field-label">Dimensiones * (máximo 4)</label>
              <div class="multiselect-container">
                <div class="selected-dimensions" *ngIf="paperForm.dimensions && paperForm.dimensions.length > 0">
                  <span class="dimension-tag" *ngFor="let dimensionId of paperForm.dimensions; let i = index">
                    {{ getDimensionNameById(dimensionId) }}
                    <button type="button" class="remove-dimension" (click)="removeDimension(i)" aria-label="Eliminar dimensión">
                      ×
                    </button>
                  </span>
                </div>
                <div class="multiselect-dropdown" [class.open]="dimensionDropdownOpen">
                  <button 
                    type="button" 
                    class="multiselect-trigger"
                    (click)="toggleDimensionDropdown(); $event.stopPropagation()"
                    [disabled]="paperForm.dimensions && paperForm.dimensions.length >= 4"
                  >
                    <span *ngIf="!paperForm.dimensions || paperForm.dimensions.length === 0">
                      Seleccionar dimensiones
                    </span>
                    <span *ngIf="paperForm.dimensions && paperForm.dimensions.length > 0 && paperForm.dimensions.length < 4">
                      Agregar más dimensiones ({{ paperForm.dimensions.length }}/4)
                    </span>
                    <span *ngIf="paperForm.dimensions && paperForm.dimensions.length >= 4">
                      Máximo alcanzado (4/4)
                    </span>
                    <span class="dropdown-arrow">▼</span>
                  </button>
                  <div class="multiselect-options" *ngIf="dimensionDropdownOpen">
                    <div 
                      class="multiselect-option" 
                      *ngFor="let dim of dimensions"
                      [class.disabled]="isDimensionSelected(dim.id)"
                      (click)="toggleDimension(dim.id); $event.stopPropagation()"
                    >
                      <input 
                        type="checkbox" 
                        [checked]="isDimensionSelected(dim.id)"
                        [disabled]="!isDimensionSelected(dim.id) && paperForm.dimensions && paperForm.dimensions.length >= 4"
                        (change)="toggleDimension(dim.id); $event.stopPropagation()"
                      >
                      <label>{{ dim.name }}</label>
                    </div>
                    <div class="no-dimensions" *ngIf="dimensions.length === 0">
                      No hay dimensiones disponibles
                    </div>
                  </div>
                </div>
                <div class="dimension-error" *ngIf="dimensionError">
                  {{ dimensionError }}
                </div>
              </div>
            </div>
            <div class="form-field">
              <label class="field-label">Título</label>
              <input 
                type="text" 
                class="field-input" 
                placeholder="Ingrese titutlo"
                [(ngModel)]="paperForm.title"
                name="paper-title"
                maxlength="200">
            </div>
          </div>
          
          <!-- Descripción -->
          <div class="form-field full-width">
            <label class="field-label">Descripción</label>
            <textarea 
              class="field-textarea" 
              placeholder="Ingrese descripción 200 caracteres como maximo"
              [(ngModel)]="paperForm.description"
              name="paper-description"
              maxlength="200"
              rows="3"></textarea>
          </div>
          
          <!-- Lo que aprenderás -->
          <div class="form-field full-width">
            <label class="field-label">Lo que aprenderás</label>
            <input 
              *ngFor="let point of paperForm.learningPoints; let i = index; trackBy: trackByLearningPointIndex"
              type="text" 
              class="field-input learning-input" 
              placeholder="Ingrese 90 caracteres como máximo"
              [ngModel]="paperForm.learningPoints[i]"
              (ngModelChange)="onLearningPointChange(i, $event)"
              [name]="'learningPoint' + i"
              maxlength="90">
          </div>
          
          <!-- Etiquetas/Hashtag -->
          <div class="form-field full-width">
            <label class="field-label">Etiquetas/Hashtag</label>
            <div class="tags-grid">
              <input 
                *ngFor="let tag of paperForm.tags; let i = index; trackBy: trackByTagIndex"
                type="text" 
                class="field-input tag-input" 
                placeholder="Ingrese"
                [ngModel]="paperForm.tags[i]"
                (ngModelChange)="onTagChange(i, $event)"
                [name]="'tag' + i">
            </div>
          </div>
          
          <!-- Subir archivo -->
        <div class="form-row">
            <div class="form-field">
              <label class="field-label">Subir archivo</label>
              <div class="file-upload-area">
                <input 
                  type="text" 
                  class="field-input file-display" 
                  [value]="selectedPdfFile ? selectedPdfFile.name : 'Haz clic para seleccionar un PDF'"
                  readonly>
                <input 
                  type="file" 
                  class="file-input" 
                  #pdfFileInput
                  accept=".pdf"
                  (change)="onPaperFileSelected($any($event))">
              </div>
              <div class="file-upload-helper" [class.success]="selectedPdfFile">
                <i class="fas" [ngClass]="selectedPdfFile ? 'fa-check-circle' : 'fa-cloud-upload-alt'"></i>
                <span>{{ selectedPdfFile ? 'PDF listo para cargar' : 'Haz clic o arrastra tu archivo PDF (máx. 10MB)' }}</span>
              </div>
              <div class="file-actions" *ngIf="paperForm.fileUrl && !selectedPdfFile">
                <a [href]="getPaperFileUrl(paperForm.fileUrl)" target="_blank" rel="noopener noreferrer">
                  <i class="fas fa-download"></i> Descargar archivo actual
                </a>
                <!-- <button type="button" class="file-change-btn" (click)="triggerPdfUpload()">
                  <i class="fas fa-sync-alt"></i> Reemplazar archivo
                </button> -->
              </div>
            </div>
            <div class="form-field">
              <label class="field-label">Portada</label>
              <div class="file-upload-area">
                <input 
                  type="text" 
                  class="field-input file-display" 
                  [value]="selectedCoverFile ? selectedCoverFile.name : 'Haz clic para cargar una imagen'"
                  readonly>
                <input 
                  type="file" 
                  class="file-input" 
                  #coverFileInput
                  accept="image/*"
                  (change)="onPaperCoverSelected($any($event))">
              </div>
              <div class="file-upload-helper" [class.success]="selectedCoverFile">
                <i class="fas" [ngClass]="selectedCoverFile ? 'fa-check-circle' : 'fa-image'"></i>
                <span>
                  {{ selectedCoverFile ? 'Portada seleccionada correctamente' : 'Sube una imagen de portada para el paper (JPG o PNG)' }}
                </span>
              </div>
              <div class="file-actions" *ngIf="paperForm.coverUrl && !selectedCoverFile">
                <a [href]="getPaperCoverUrl(paperForm.coverUrl)" target="_blank" rel="noopener noreferrer">
                  <i class="fas fa-eye"></i> Ver portada actual
                </a>
                <!-- <a [href]="getPaperCoverUrl(paperForm.coverUrl)" download>
                  <i class="fas fa-download"></i> Descargar portada
                </a> -->
                <!-- <button type="button" class="file-change-btn" (click)="triggerCoverUpload()">
                  <i class="fas fa-sync-alt"></i> Reemplazar portada
                </button> -->
              </div>
            </div>
          </div>
        </form>
      </div>
      
      <!-- Botones del modal -->
      <div class="modal-footer">
        <button class="btn-draft" (click)="saveAsDraft()">
          Guardar como borrador
        </button>
        <button class="btn-request-review" (click)="requestReview()">
          Solicitar revisión
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Vista normal de Academy (para usuarios regulares) -->
<div class="academy-container" *ngIf="!isManagementView">
  <!-- Header con breadcrumb -->
  <!-- <div class="breadcrumb">
    <span>Academy</span>
  </div> -->

  <!-- Título principal -->
  <div class="main-title">
    <h1>BIENVENIDO A PHOENIX ACADEMY</h1>
    <p class="subtitle">Disfruta de herramientas como</p>
  </div>

  <!-- Pestañas principales -->
  <div class="main-tabs">
    <button 
      class="tab-button" 
      [class.active]="activeMainTab === 'lecturas'"
      (click)="setActiveMainTab('lecturas')">
      <img src="assets/icons/papers.svg" alt="Papers" class="tab-icon" />
      Lecturas
    </button>
    <button disabled
      class="tab-button tab-button-disabled" 
      [class.active]="activeMainTab === 'videos'"
      (click)="setActiveMainTab('videos')">
      <img src="assets/icons/videos.svg" alt="Videos" class="tab-icon" />
      Videos cortos a tu ritmo
    </button>
  </div>

  <!-- Sección de LECTURAS -->
  <div class="lecturas-section" *ngIf="activeMainTab === 'lecturas'">
    <h2 class="section-title">LECTURAS</h2>
    
    <!-- Filtros de categorías -->
    <div class="category-filters">
      <ng-container *ngFor="let category of categories">
        <button 
          *ngIf="category.count > 0"
          class="category-button"
          [class.active]="activeFilter === category.id"
          (click)="setActiveFilter(category.id)">
          {{ category.name }} <span class="count">({{ category.count }})</span>
        </button>
      </ng-container>
      <!-- Commented because, at the moment, does nothing -->
      <!--div class="filter-dropdown">
        <button class="dropdown-toggle">
          <i class="fa-solid fa-chevron-down"></i>
        </button>
      </div-->
    </div>

    <!-- Selector de ordenamiento -->
    <div class="sort-options">
      <span>Más recientes</span>
      <i class="fa-solid fa-chevron-down"></i>
    </div>

    <!-- Grid de papers -->
    <div class="content-grid" [class.few-items]="shouldShowFewItems()" *ngIf="getCurrentPapers().length > 0">
      <div 
        *ngFor="let paper of getCurrentPapers()" 
        class="content-card paper-card">
        
        <div class="card-image">
          <img [src]="getPaperCover(paper)" [alt]="paper.title" />
        </div>

        <div class="card-content">
          <div class="card-category-tag">
            <span class="tag"
                  *ngIf="(paper.categories || []).length > 0"
                  [style.background-color]="getCategoryColor((paper.categories || [])[0].id)">
              {{ (paper.categories || [])[0].name }}
            </span>
            <span class="tag tag-additional"
                  *ngIf="(paper.categories || []).length > 1"
                  [style.background-color]="getCategoryColor((paper.categories || [])[0].id)"
                  [title]="getAdditionalCategoriesTooltip(paper.categories || [])">
              +{{ (paper.categories || []).length - 1 }}
            </span>
          </div>
          <h3 class="card-title">{{paper.title}}</h3>
          <div class="card-subtitle">
            <span class="date-format">{{formatPaperDate(paper.publishedDate)}}</span>
          </div>
          <p class="card-description">{{paper.description}}</p>

          <hr class="divider">
          
          <button 
            class="detail-button"
            (click)="goToDetail(paper._id!)">
            Ver detalle
          </button>
        </div>
      </div>
    </div>
    
    <!-- Mensaje cuando no hay papers -->
    <div class="no-papers-message" *ngIf="getCurrentPapers().length === 0">
      <div class="empty-state-content">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" stroke-width="2" fill="none"/>
          <path d="M14 2v6h6" stroke="currentColor" stroke-width="2"/>
          <path d="M16 13H8M16 17H8M10 9H8" stroke="currentColor" stroke-width="2"/>
        </svg>
        <h3>No hay papers disponibles</h3>
        <p>No se encontraron papers activos en este momento. Vuelve más tarde para ver nuevo contenido.</p>
      </div>
    </div>
    
    <!-- Paginador para Lecturas -->
    <div class="pagination-container" *ngIf="totalPages > 1">
      <div class="pagination-info">
        <span>Mostrando {{((currentPage - 1) * itemsPerPage) + 1}} de {{totalItems}} resultados</span>
      </div>
      
      <div class="pagination-controls">
        <button 
          class="pagination-btn prev-btn" 
          [disabled]="currentPage === 1"
          (click)="previousPage()">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        
        <div class="page-numbers">
          <button 
            *ngFor="let page of getPageNumbers()" 
            class="page-btn"
            [class.active]="page === currentPage"
            (click)="goToPage(page)">
            {{page}}
          </button>
          
          <span *ngIf="totalPages > 5 && currentPage < totalPages - 2" class="dots">...</span>
          
          <button 
            *ngIf="totalPages > 5 && currentPage < totalPages - 2"
            class="page-btn"
            (click)="goToPage(totalPages)">
            {{totalPages}}
          </button>
        </div>
        
        <button 
          class="pagination-btn next-btn" 
          [disabled]="currentPage === totalPages"
          (click)="nextPage()">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
      
      <div class="items-per-page">
        <span>Mostrar</span>
        <select 
          class="items-select" 
          [value]="itemsPerPage" 
          (change)="changeItemsPerPage(+($any($event.target).value))">
          <option value="8">8</option>
          <option value="12">12</option>
          <option value="16">16</option>
          <option value="20">20</option>
        </select>
      </div>
    </div>
  </div>

  <!-- Sección de VIDEOS -->
  <div class="videos-section" *ngIf="activeMainTab === 'videos'">
    <!-- <h2 class="section-title">VIDEOS CORTOS A TU RITMO</h2> -->
    
    <!-- Filtros de categorías -->
    <div class="category-filters">
      <button 
        *ngFor="let category of categories" 
        class="category-button"
        [class.active]="activeFilter === category.id"
        (click)="setActiveFilter(category.id)">
        {{category.name}} <span class="count">({{category.count}})</span>
      </button>
      <div class="filter-dropdown">
        <button class="dropdown-toggle">
          <i class="fa-solid fa-chevron-down"></i>
        </button>
      </div>
    </div>

    <!-- Selector de ordenamiento -->
    <div class="sort-options">
      <span>Más recientes</span>
      <i class="fa-solid fa-chevron-down"></i>
    </div>

    <!-- Grid de videos -->
    <div class="content-grid">
      <div 
        *ngFor="let video of getCurrentVideos()" 
        class="content-card video-card"
        (click)="goToDetail(video._id!)">
        
        <div class="card-image">
          <img [src]="getVideoThumbnail(video)" [alt]="video.title" />
          <div class="play-overlay">
            <i class="fa-solid fa-play"></i>
          </div>
          <div class="card-overlay">
            <div class="card-tags">
              <span class="tag" 
                    *ngIf="video.category" 
                    [style.background-color]="getCategoryColor(video.category)">
                {{getCategoryName(video.category)}}
              </span>
            </div>
          </div>
        </div>

        <div class="card-content">
          <h3 class="card-title">{{video.title}}</h3>
          <div class="card-meta">
            <span class="duration">{{video.duration || '5 min'}}</span>
          </div>
          <p class="card-description">{{video.description}}</p>
          
          <div class="card-actions">
            <button 
              *ngIf="!video.isFree" 
              class="action-button price-button"
              (click)="$event.stopPropagation(); buyItem(video._id!)">
              <i class="fa-solid fa-shopping-cart"></i>
              Comprar S/.{{video.price}}
            </button>
            <button 
              *ngIf="video.isFree" 
              class="action-button play-button"
              (click)="$event.stopPropagation(); playOrDownload(video._id!)">
              <i class="fa-solid fa-play"></i>
              Reproducir gratis
            </button>
            <button 
              class="action-button save-button"
              [class.saved]="isVideoSaved(video._id!)"
              (click)="$event.stopPropagation(); saveItem(video)">
              <i class="fa-solid fa-bookmark"></i>
            </button>
          </div>

          <div class="card-stats">
            <div class="stat">
              <i class="fa-solid fa-eye"></i>
              <span>{{formatViewCount(video.views)}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Paginador para Videos -->
    <div class="pagination-container" *ngIf="totalPages > 1">
      <div class="pagination-info">
        <span>Mostrando {{((currentPage - 1) * itemsPerPage) + 1}} de {{totalItems}} resultados</span>
      </div>
      
      <div class="pagination-controls">
        <button 
          class="pagination-btn prev-btn" 
          [disabled]="currentPage === 1"
          (click)="previousPage()">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
        
        <div class="page-numbers">
          <button 
            *ngFor="let page of getPageNumbers()" 
            class="page-btn"
            [class.active]="page === currentPage"
            (click)="goToPage(page)">
            {{page}}
          </button>
          
          <span *ngIf="totalPages > 5 && currentPage < totalPages - 2" class="dots">...</span>
          
          <button 
            *ngIf="totalPages > 5 && currentPage < totalPages - 2"
            class="page-btn"
            (click)="goToPage(totalPages)">
            {{totalPages}}
          </button>
        </div>
        
        <button 
          class="pagination-btn next-btn" 
          [disabled]="currentPage === totalPages"
          (click)="nextPage()">
          <i class="fa-solid fa-chevron-right"></i>
        </button>
      </div>
      
      <div class="items-per-page">
        <span>Mostrar</span>
        <select 
          class="items-select" 
          [value]="itemsPerPage" 
          (change)="changeItemsPerPage(+($any($event.target).value))">
          <option value="8">8</option>
          <option value="12">12</option>
          <option value="16">16</option>
          <option value="20">20</option>
        </select>
      </div>
    </div>
  </div>

  <!-- Spinner de carga -->
  <ngx-spinner name="loading" [fullScreen]="true"></ngx-spinner>
</div>

<!-- Modal de vista previa de paper -->
<div class="modal-overlay" *ngIf="showPaperPreview" (click)="closePaperPreview()">
  <div class="modal-container paper-preview-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Vista previa del paper</h3>
      <p class="modal-subtitle" *ngIf="paperPreviewData">
        {{ paperPreviewData.title }}
      </p>
      <button class="close-modal-btn" (click)="closePaperPreview()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="modal-content paper-preview-content" *ngIf="paperPreviewData; else loadingPaperPreview">
      <div class="paper-preview-header">
        <div class="cover">
          <div class="cover-frame">
            <img [src]="paperPreviewData.coverUrl || 'assets/images/paper-placeholder.jpg'" [alt]="paperPreviewData.title">
          </div>
        </div>
        <div class="info">
          <span class="paper-type-pill">Paper interno</span>
          <h4 class="title">{{ paperPreviewData.title }}</h4>
          <div class="meta-grid">
            <div class="meta-item">
              <i class="fa-solid fa-user"></i>
              <span>Autor</span>
              <strong>{{ paperPreviewData.authorName || 'No disponible' }}</strong>
            </div>
            <div class="meta-item">
              <i class="fa-solid fa-layer-group"></i>
              <span>Dimensión</span>
              <strong>{{ getPaperDimensionName(paperPreviewData.category) }}</strong>
            </div>
            <div class="meta-item" *ngIf="paperPreviewData.publishedDate">
              <i class="fa-solid fa-calendar-day"></i>
              <span>Publicado</span>
              <strong>{{ formatPaperDate(paperPreviewData.publishedDate) }}</strong>
            </div>
          </div>
          <div class="tags" *ngIf="paperPreviewData.tags?.length">
            <span class="tag" *ngFor="let tag of paperPreviewData.tags">#{{ tag }}</span>
          </div>
        </div>
      </div>

      <div class="paper-preview-body">
        <section class="paper-preview-section" *ngIf="paperPreviewData.summary">
          <h5>Resumen</h5>
          <p>{{ paperPreviewData.summary }}</p>
        </section>

        <section class="paper-preview-section" *ngIf="paperPreviewData.content">
          <h5>Contenido</h5>
          <div class="paper-preview-html" [innerHTML]="paperPreviewData.content"></div>
        </section>

        <section class="paper-preview-section" *ngIf="paperPreviewData.learningObjectives?.length">
          <h5>Objetivos de aprendizaje</h5>
          <ul class="custom-list">
            <li *ngFor="let objective of paperPreviewData.learningObjectives">{{ objective }}</li>
          </ul>
        </section>

        <section class="paper-preview-section" *ngIf="paperPreviewData.learningPoints?.length">
          <h5>Puntos clave</h5>
          <ul class="custom-list">
            <li *ngFor="let point of paperPreviewData.learningPoints">{{ point }}</li>
          </ul>
        </section>
      </div>

      <div class="paper-preview-actions">
        <button class="btn-primary" (click)="navigateToPublicPaper(paperPreviewData._id)">
          <i class="fa-solid fa-arrow-up-right-from-square"></i>
          Ver en portal de usuarios
        </button>
      </div>
    </div>

    <ng-template #loadingPaperPreview>
      <div class="paper-preview-loading">
        <i class="fas fa-spinner fa-spin"></i>
        <p>Cargando vista previa...</p>
      </div>
    </ng-template>
  </div>
</div>